/**
 * Client Call Type for client to make call w.r.t. audio, video, presentation direction
 */

export enum ClientCallType {
    /**
     * Client to join as a control-only participant, i.e. the
     * user will not send or receive any audio or video. They
     * can still access the conference controls.
     */
    None = 0,
    /**
     * Join as a sending-audio-only participant, not receiving
     * any audio, also will not send or receive video.
     */
    AudioSendOnly = 1 << 1,
    /**
     * Join as a receiving-audio-only participant, not sending
     * any audio, also will not send or receive video.
     */
    AudioRecvOnly = 1 << 2,
    /**
     * Join as a sending-video-only participant, not receiving
     * any video, also will not send or receive audio.
     */
    VideoSendOnly = 1 << 3,
    /**
     * Join as a receiving-video-only participant, not sending
     * any video, also will not send or receive audio.
     */
    VideoRecvOnly = 1 << 4,
    /**
     * Join as a sending-presentation-only participant.
     */
    PresentationSendOnly = 1 << 5,
    /**
     * Join as a receiving-presentation-only participant.
     */
    PresentationRecvOlly = 1 << 6,
    /**
     * Join as an audio-only participant, i.e. the user will send and receive
     * audio but will not send or receive video.
     */
    Audio = AudioSendOnly | AudioRecvOnly,
    /**
     * Join as a video-only participant, i.e. the user will send and receive
     * video but will not send or receive audio.
     */
    Video = VideoSendOnly | VideoRecvOnly,
    /**
     * Join as a presentation only participant
     */
    Presentation = PresentationSendOnly | PresentationRecvOlly,
    AudioRecvOnlyPresentation = AudioRecvOnly | Presentation,
    AudioSendOnlyPresentation = AudioSendOnly | Presentation,
    VideoRecvOnlyPresentation = VideoRecvOnly | Presentation,
    VideoSendOnlyPresentation = VideoSendOnly | Presentation,
    /**
     * Join as a sending-audio-video-only participant, i.e. the user will only
     * send audio and video but will not receive audio or video.
     */
    AudioSendVideoSendOnly = AudioSendOnly | VideoSendOnly,
    /**
     * Join as a sending-audio-video-presentation-only participant, i.e. the
     * user will only send audio, video, and presentation but will not
     * receive audio, video, or presentation.
     */
    AudioSendVideoSendPresentationSendOnly = AudioSendVideoSendOnly |
        PresentationSendOnly,
    /**
     * Join as a receiving-audio-video-only participant, i.e. the user will only
     * receive audio and video but will not send audio or video.
     */
    AudioRecvVideoRecvOnly = AudioRecvOnly | VideoRecvOnly,
    /**
     * Join as a receiving-audio-video-presentation-only participant, i.e. the
     * user will only receive audio, video, and presentation but will not send
     * audio, video, or presentation.
     */
    AudioRecvVideoRecvPresentationRecvOnly = AudioRecvVideoRecvOnly |
        PresentationRecvOlly,
    AudioRecvVideoRecvOnlyPresentation = AudioRecvVideoRecvOnly | Presentation,
    AudioSendVideoSendOnlyPresentation = AudioSendVideoSendOnly | Presentation,
    /**
     * Join as a full (send and receive) audio and presentation participant
     */
    AudioPresentation = Audio | Presentation,
    /**
     * Join as a full (send and receive) video and presentation participant
     */
    VideoPresentation = Video | Presentation,
    /**
     * Join as a full (send and receive) audio and video participant
     */
    AudioVideo = Audio | Video,
    /**
     * Join as a full (send and receive) audio, video, and presentation participant
     */
    AudioVideoPresentation = Audio | Video | Presentation,
}
